import { inject, Service } from '@angular/core';
import { HttpService } from '@data-services/http/http.service';

@Service()
export class ProjectArchiveDataService {
  private readonly http = inject(HttpService);

  async downloadProjectArchiveAsync(projectId: string): Promise<Blob> {
    const response = await this.http.getBlobAsync(`archive/projects/${projectId}`);
    return response.body ?? new Blob();
  }

  async restoreProjectArchiveAsync(file: File): Promise<void> {
    const blob = new Blob([file], { type: 'application/octet-stream' });
    await this.http.postObjectAsync<Blob, void>('archive/restore', blob);
  }
}
